import { render, staticRenderFns } from "./exception.vue?vue&type=template&id=25dcc22b&scoped=true"
import script from "./exception.vue?vue&type=script&lang=ts"
export * from "./exception.vue?vue&type=script&lang=ts"
import style0 from "./exception.vue?vue&type=style&index=0&id=25dcc22b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dcc22b",
  null
  
)

export default component.exports